import React from "react";
import { IInvoice } from "@src/types/invoice";
import InvoiceForm from "./components/InvoiceForm";

interface CuratorInvoicePageProps {
  onToggleView: () => void;
  invoice?: IInvoice | null;
}

const CuratorInvoicePage = ({
  onToggleView,
  invoice,
}: CuratorInvoicePageProps): React.JSX.Element => {
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <InvoiceForm onSuccess={onToggleView} invoice={invoice} />
    </div>
  );
};

export default CuratorInvoicePage;
